/* Funeral Service Planner — contact → religion → services with tiered, location-aware options */
(function () {
  'use strict';

  var root = document.getElementById('fs-planner');
  var dataEl = document.getElementById('fs-planner-data');
  if (!root || !dataEl) return;

  // Move the overlay and launcher to <body> so no theme wrapper (sticky header, transforms) can clip them
  document.body.appendChild(root);
  var launcherEl = document.querySelector('[data-fs-open].fs-launcher');
  if (launcherEl) document.body.appendChild(launcherEl);

  var cfg = safeJSON(root.getAttribute('data-config'), {});
  var data = safeJSON(dataEl.textContent, { services: [], options: [] });
  var RADIUS = Number(cfg.radius) || 20;
  var MAX = Number(cfg.maxOptions) || 3;
  var STORE_KEY = 'fs_planner_v1';
  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency || 'USD', maximumFractionDigits: 0 });

  var state = Object.assign({ step: 'contact', lead: null, religion: '', coords: null, picks: {}, leadSent: false, seen: false }, load());

  // ---------- helpers ----------
  function safeJSON(s, fb) { try { return JSON.parse(s); } catch (e) { return fb; } }
  function load() { try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; } }
  function save() { try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function money(n) { return fmt.format(Number(n) || 0); }

  function religionOk(item, religion) {
    var list = item.religions;
    if (!list || !list.length) return true;
    return list.some(function (r) {
      var v = String(r).trim().toLowerCase();
      return v === 'all' || v === String(religion).trim().toLowerCase();
    });
  }

  function miles(a, b) {
    var R = 3958.8, toRad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toRad, dLng = (b.lng - a.lng) * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a.lat * toRad) * Math.cos(b.lat * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function addressString(l) { return [l.street, l.city, l.state, l.zip].filter(Boolean).join(', '); }

  async function geocode(lead) {
    var q = encodeURIComponent(addressString(lead));
    try {
      if (cfg.googleKey) {
        var g = await fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + q + '&key=' + encodeURIComponent(cfg.googleKey)).then(function (r) { return r.json(); });
        if (g.results && g.results[0]) return { lat: g.results[0].geometry.location.lat, lng: g.results[0].geometry.location.lng };
      } else {
        var n = await fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=us&q=' + q, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        if (n && n[0]) return { lat: parseFloat(n[0].lat), lng: parseFloat(n[0].lon) };
        // fall back to ZIP only
        if (lead.zip) {
          var z = await fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=us&postalcode=' + encodeURIComponent(lead.zip)).then(function (r) { return r.json(); });
          if (z && z[0]) return { lat: parseFloat(z[0].lat), lng: parseFloat(z[0].lon) };
        }
      }
    } catch (e) { /* network or quota failure: options shown without distance filter */ }
    return null;
  }

  // Spread picks across the price range: most expensive, cheapest, and evenly between.
  function spread(sortedDesc, max) {
    if (sortedDesc.length <= max) return sortedDesc;
    if (max === 1) return [sortedDesc[0]];
    var out = [], n = sortedDesc.length;
    for (var i = 0; i < max; i++) out.push(sortedDesc[Math.round(i * (n - 1) / (max - 1))]);
    return out;
  }

  // Returns { options: [...], note: '' } for one service
  function optionsFor(service) {
    var all = data.options.filter(function (o) { return o.service === service.handle && religionOk(o, state.religion); });
    if (!all.length) return { options: [], note: '' };

    var located = all.filter(function (o) { return typeof o.lat === 'number' && typeof o.lng === 'number'; });
    var plain = all.filter(function (o) { return located.indexOf(o) === -1; });
    var note = '';
    var chosen;

    if (located.length) {
      if (state.coords) {
        located.forEach(function (o) { o.distance = miles(state.coords, o); });
        var near = located.filter(function (o) { return o.distance <= RADIUS; });
        if (!near.length) {
          near = located.slice().sort(function (a, b) { return a.distance - b.distance; }).slice(0, MAX);
          note = 'No options within ' + RADIUS + ' miles of your address — showing the nearest.';
        }
        chosen = spread(near.sort(function (a, b) { return b.price - a.price; }), MAX);
      } else {
        located.forEach(function (o) { delete o.distance; });
        chosen = spread(located.sort(function (a, b) { return b.price - a.price; }), MAX);
        note = "We couldn't confirm distances for your address; a director will confirm the closest locations.";
      }
      chosen = chosen.concat(plain);
    } else {
      chosen = plain;
    }
    chosen.sort(function (a, b) { return b.price - a.price; });
    return { options: chosen, note: note };
  }

  function servicesForReligion() {
    return data.services
      .filter(function (s) { return religionOk(s, state.religion); })
      .sort(function (a, b) { return (a.sort - b.sort) || String(a.name).localeCompare(b.name); });
  }

  // ---------- rendering ----------
  function show(step) {
    state.step = step; save();
    $$('.fs-step').forEach(function (el) { el.hidden = el.getAttribute('data-step') !== step; });
    var order = ['contact', 'religion', 'services'];
    var idx = order.indexOf(step === 'done' ? 'services' : step);
    $$('[data-step-dot]').forEach(function (li) {
      var i = order.indexOf(li.getAttribute('data-step-dot'));
      li.classList.toggle('is-active', i === idx);
      li.classList.toggle('is-done', i < idx || step === 'done');
    });
    var first = $('.fs-step[data-step="' + step + '"] input, .fs-step[data-step="' + step + '"] select, .fs-step[data-step="' + step + '"] button');
    if (first) setTimeout(function () { first.focus(); }, 30);
  }

  function renderServices() {
    var wrap = $('[data-services]');
    var list = servicesForReligion();
    $('[data-services-lede]').textContent = 'Services for ' + state.religion + ' traditions near ' + (state.lead ? state.lead.city || state.lead.zip : 'you') + '. Select what you need; prices are shown from highest to lowest.';
    $('[data-disclaimer]').textContent = cfg.disclaimer || '';

    if (!list.length) {
      wrap.innerHTML = '<p class="fs-empty">Our directors will prepare options for you. Press “Send me this plan” and we will call you.</p>';
      updateTotal();
      return;
    }

    wrap.innerHTML = list.map(function (s) {
      var res = optionsFor(s);
      var pick = state.picks[s.handle];
      // recommended services start included, preselecting the middle-priced option (never upsell by default)
      var middle = res.options.length ? res.options[Math.floor((res.options.length - 1) / 2)].handle : 'base';
      if (pick === undefined) pick = s.recommended ? middle : null;
      // keep a stored pick only if it is still offered (address or religion may have changed)
      if (pick && pick !== 'base' && !res.options.some(function (o) { return o.handle === pick; })) pick = middle;
      if (pick === 'base' && res.options.length) pick = middle;
      state.picks[s.handle] = pick;
      var included = !!pick;

      var head =
        '<label class="fs-svc__head">' +
          '<input type="checkbox" data-svc-toggle="' + esc(s.handle) + '"' + (included ? ' checked' : '') + '>' +
          '<span class="fs-svc__name">' + esc(s.name) + '</span>' +
          '<span class="fs-svc__price">' + (res.options.length ? 'from ' + money(Math.min.apply(null, res.options.map(function (o) { return o.price; }))) : money(s.price)) + '</span>' +
        '</label>' +
        (s.description ? '<p class="fs-svc__desc">' + esc(s.description) + '</p>' : '') +
        (s.priceNote ? '<p class="fs-fineprint">' + esc(s.priceNote) + '</p>' : '');

      var opts = '';
      if (res.options.length) {
        opts = '<div class="fs-opts" role="radiogroup" aria-label="' + esc(s.name) + ' options">' +
          res.options.map(function (o) {
            var meta = [o.tier, typeof o.distance === 'number' ? o.distance.toFixed(1) + ' mi away' : null, o.address].filter(Boolean).map(esc).join(' · ');
            return '<label class="fs-opt">' +
              '<input type="radio" name="fs-opt-' + esc(s.handle) + '" value="' + esc(o.handle) + '" data-svc="' + esc(s.handle) + '"' + (pick === o.handle ? ' checked' : '') + '>' +
              (o.image ? '<img src="' + esc(o.image) + '" alt="" loading="lazy" width="64" height="64">' : '') +
              '<span class="fs-opt__body"><span class="fs-opt__name">' + esc(o.name) + '</span>' +
                (meta ? '<span class="fs-opt__meta">' + meta + '</span>' : '') +
                (o.description ? '<span class="fs-opt__desc">' + esc(o.description) + '</span>' : '') +
              '</span>' +
              '<span class="fs-opt__price">' + money(o.price) + '</span>' +
            '</label>';
          }).join('') +
        '</div>' + (res.note ? '<p class="fs-fineprint">' + esc(res.note) + '</p>' : '');
      }

      return '<section class="fs-svc' + (included ? ' is-included' : '') + '" data-svc-card="' + esc(s.handle) + '">' + head + opts + '</section>';
    }).join('');

    save();
    updateTotal();
  }

  function selectedItems() {
    var items = [];
    servicesForReligion().forEach(function (s) {
      var pick = state.picks[s.handle];
      if (!pick) return;
      if (pick === 'base') { items.push({ service: s.name, option: null, price: s.price, variantId: s.variantId }); return; }
      var o = data.options.filter(function (x) { return x.handle === pick; })[0];
      if (o) items.push({ service: s.name, option: o.name, tier: o.tier, price: o.price, variantId: o.variantId || s.variantId, distance: o.distance });
    });
    return items;
  }

  function updateTotal() {
    var items = selectedItems();
    $('[data-total]').textContent = money(items.reduce(function (t, i) { return t + (Number(i.price) || 0); }, 0));
    $('[data-fs-cart]').hidden = !items.some(function (i) { return i.variantId; });
  }

  // ---------- Shopify contact form submission ----------
  async function sendToShop(fields) {
    var form = document.getElementById('fs-lead-form');
    if (!form) throw new Error('Contact form missing');
    var fd = new FormData(form);
    Object.keys(fields).forEach(function (k) { fd.append('contact[' + k + ']', fields[k]); });
    var res = await fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: fd, credentials: 'same-origin' });
    if (res.url && res.url.indexOf('/challenge') !== -1) {
      // Shopify asked for a spam check: submit the real form in a new tab so it still goes through
      Object.keys(fields).forEach(function (k) {
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'contact[' + k + ']'; i.value = fields[k]; form.appendChild(i);
      });
      form.target = '_blank'; form.submit();
    } else if (!res.ok) {
      throw new Error('Submit failed');
    }
  }

  function leadFields(extra) {
    var l = state.lead || {};
    return Object.assign({
      name: l.name, email: l.email, phone: l.phone,
      Address: addressString(l),
      Religion: state.religion || '(not chosen yet)'
    }, extra || {});
  }

  function setError(stepEl, msg) {
    var e = $('[data-error]', stepEl); if (!e) return;
    e.textContent = msg || ''; e.hidden = !msg;
  }

  // ---------- open / close ----------
  var launcher = document.querySelector('.fs-launcher');
  function open() {
    root.hidden = false; document.documentElement.classList.add('fs-lock');
    if (launcher) launcher.hidden = true;
    if (state.step === 'services' && state.lead && state.religion) { renderServices(); show('services'); }
    else if (state.step === 'religion' && state.lead) show('religion');
    else if (state.step === 'done') show(state.lead && state.religion ? 'services' : 'contact');
    else show(state.lead ? 'religion' : 'contact');
    if (state.lead) prefill();
  }
  function close() {
    if (!cfg.allowSkip && state.step !== 'done') return;
    root.hidden = true; document.documentElement.classList.remove('fs-lock');
    if (launcher) launcher.hidden = false;
    state.seen = true; save();
  }
  function prefill() {
    var f = $('form[data-step="contact"]');
    Object.keys(state.lead || {}).forEach(function (k) { if (f.elements[k]) f.elements[k].value = state.lead[k]; });
    if (state.religion) $('form[data-step="religion"]').elements.religion.value = state.religion;
  }

  // ---------- events ----------
  $('form[data-step="contact"]').addEventListener('submit', async function (e) {
    e.preventDefault();
    var f = e.currentTarget;
    if (!f.checkValidity()) { setError(f, 'Please complete all fields (5-digit ZIP, valid email).'); f.reportValidity(); return; }
    setError(f, '');
    var lead = {};
    ['name', 'street', 'city', 'state', 'zip', 'phone', 'email'].forEach(function (k) { lead[k] = f.elements[k].value.trim(); });
    var changedAddress = !state.lead || addressString(state.lead) !== addressString(lead);
    state.lead = lead;
    if (changedAddress) state.coords = null;
    save();
    show('religion');
    // capture the lead right away so a director can follow up even if the family stops here
    if (!state.leadSent) {
      sendToShop(leadFields({ body: 'New lead from the website planner (step 1).' }))
        .then(function () { state.leadSent = true; save(); })
        .catch(function () {});
    }
    if (!state.coords) geocode(lead).then(function (c) { state.coords = c; save(); if (state.step === 'services') renderServices(); });
  });

  $('form[data-step="religion"]').addEventListener('submit', function (e) {
    e.preventDefault();
    var v = e.currentTarget.elements.religion.value;
    if (!v) { setError(e.currentTarget, 'Please choose an option.'); return; }
    setError(e.currentTarget, '');
    if (v !== state.religion) state.picks = {};
    state.religion = v; save();
    renderServices();
    show('services');
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-svc-toggle')) {
      var h = t.getAttribute('data-svc-toggle');
      var card = $('[data-svc-card="' + CSS.escape(h) + '"]');
      if (t.checked) {
        var radio = $('input[type=radio]:checked', card) || $('input[type=radio]', card);
        if (radio) radio.checked = true;
        state.picks[h] = radio ? radio.value : 'base';
      } else {
        state.picks[h] = null;
        $$('input[type=radio]', card).forEach(function (r) { r.checked = false; });
      }
      card.classList.toggle('is-included', t.checked);
    } else if (t.type === 'radio' && t.hasAttribute('data-svc')) {
      var s = t.getAttribute('data-svc');
      state.picks[s] = t.value;
      var c = $('[data-svc-card="' + CSS.escape(s) + '"]');
      $('[data-svc-toggle]', c).checked = true; c.classList.add('is-included');
    } else { return; }
    save(); updateTotal();
  });

  $('[data-fs-send]').addEventListener('click', async function (e) {
    var btn = e.currentTarget, step = $('.fs-step[data-step="services"]');
    var items = selectedItems();
    var total = items.reduce(function (t, i) { return t + (Number(i.price) || 0); }, 0);
    var lines = items.map(function (i) {
      return '- ' + i.service + (i.option ? ': ' + i.option : '') + (i.tier ? ' (' + i.tier + ')' : '') +
        (typeof i.distance === 'number' ? ', ' + i.distance.toFixed(1) + ' mi' : '') + ' — ' + money(i.price);
    });
    btn.disabled = true; setError(step, '');
    try {
      await sendToShop(leadFields({ Plan: lines.join('\n') || '(no services selected)', 'Estimated total': money(total), body: 'Funeral plan request from the website planner.' }));
      show('done');
    } catch (err) {
      setError(step, 'We could not send your plan. Please call us, or try again.');
    } finally { btn.disabled = false; }
  });

  $('[data-fs-cart]').addEventListener('click', async function (e) {
    var btn = e.currentTarget, step = $('.fs-step[data-step="services"]');
    var items = selectedItems().filter(function (i) { return i.variantId; }).map(function (i) {
      return { id: i.variantId, quantity: 1, properties: { Family: state.lead ? state.lead.name : '', Religion: state.religion, Selection: i.option || i.service } };
    });
    if (!items.length) return;
    btn.disabled = true;
    try {
      var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!r.ok) throw new Error();
      window.location.href = '/cart';
    } catch (err) { setError(step, 'Some items could not be added to the cart.'); btn.disabled = false; }
  });

  $$('[data-fs-back]').forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-fs-back')); if (state.lead) prefill(); }); });
  $$('[data-fs-close]').forEach(function (b) { b.addEventListener('click', close); });
  $('[data-fs-close-backdrop]').addEventListener('click', close);
  $('[data-fs-close-final]').addEventListener('click', function () { root.hidden = true; document.documentElement.classList.remove('fs-lock'); if (launcher) launcher.hidden = false; state.seen = true; save(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // Any button/link with data-fs-open, or a link to #plan, opens the planner
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-fs-open], a[href$="#plan"]');
    if (!t) return;
    e.preventDefault(); open();
  });

  // ---------- start ----------
  if (launcher) launcher.hidden = false;
  if (cfg.autoOpen && !state.seen && !(window.Shopify && window.Shopify.designMode)) {
    setTimeout(open, (Number(cfg.delay) || 0) * 1000);
  }
  if (window.location.hash === '#plan') open();

  // test hook
  window.__fsPlanner = { state: state, optionsFor: optionsFor, servicesForReligion: servicesForReligion, miles: miles };
})();
